// extracted by mini-css-extract-plugin
export default {"image":"NoPageFound_image__V6nxw","title":"NoPageFound_title__YpV8u"};